// extracted by mini-css-extract-plugin
export var addressFields = "_k0-0";
export var animationContainer = "_k0-1";
export var footer = "_k0-2";
export var lineItems = "_k0-3";
export var modalContent = "_k0-4";
export var orderName = "_k0-5";
export var strong = "_k0-6";
export var warning = "_k0-7";